import React, { Component } from "react";

export default class OrderSummary extends Component {
  render() {
    if (this.props.state.batteryTenderService === true && this.props.state.rvRefrigeratorPlugin === true) {
      return (
        <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">
              Subtotal <small>(before taxes)</small>
            </span>
            <span className="float-right">
              ${(this.props.state.monthlyCost+this.props.state.batteryAddonCost+this.props.state.fridgeAddonCost).toFixed(2)}
            </span>
          </p>
      );
    } else if (this.props.state.batteryTenderService === true) {
      return (
        <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">
              Subtotal <small>(before taxes)</small>
            </span>
            <span className="float-right">
              ${(this.props.state.monthlyCost+this.props.state.batteryAddonCost).toFixed(2)}
            </span>
          </p>
      );
    } else if (this.props.state.rvRefrigeratorPlugin === true) {
      return (
        <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">
              Subtotal <small>(before taxes)</small>
            </span>
            <span className="float-right">
              ${(this.props.state.monthlyCost+this.props.state.fridgeAddonCost).toFixed(2)}
            </span>
          </p>
      );
    } else {
      return (
        <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">
              Subtotal <small>(before taxes)</small>
            </span>
            <span className="float-right">
              ${this.props.state.monthlyCost.toFixed(2)}
            </span>
          </p>
      );
    }
  }
}